import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgRsProfilePlaceholderL = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M24 0c13.255 0 24 10.745 24 24 0 3.706-.84 7.215-2.34 10.349A8 8 0 1 0 34.347 45.66 23.9 23.9 0 0 1 24 48C10.745 48 0 37.255 0 24S10.745 0 24 0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M24.847 10.053a7.657 7.657 0 0 1 7.657 7.656v4.285a7.62 7.62 0 0 1-2.458 5.615c-1.478 1.366-1.42 3.72.144 4.986.531.43 1.138.777 1.805 1.018.7.255 1.452.542 2.222.86A7.97 7.97 0 0 0 32 40c0 1.33.325 2.583.898 3.686A21.5 21.5 0 0 1 24 45.6c-6.432 0-12.204-2.814-16.161-7.274a.53.53 0 0 1 .087-.78c2.356-1.662 5.548-3.014 8.079-3.933a6.2 6.2 0 0 0 1.805-1.018c1.564-1.266 1.622-3.62.144-4.985a7.62 7.62 0 0 1-2.458-5.616V17.71a7.657 7.657 0 0 1 7.657-7.656z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.06,
        fillRule: "nonzero",
        d: "M24 0c13.122 0 23.785 10.531 23.997 23.603L48 24l-.003.397c-.058 3.56-.89 6.93-2.336 9.951a8 8 0 0 0-.782-.689 22.9 22.9 0 0 0 2.118-9.279L47 24l-.003-.38C46.794 11.092 36.575 1 24 1 11.297 1 1 11.297 1 24s10.297 23 23 23c3.45 0 6.723-.76 9.66-2.12q.318.412.687.78A23.9 23.9 0 0 1 24 48C10.745 48 0 37.255 0 24S10.745 0 24 0"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgRsProfilePlaceholderL$1 = SvgRsProfilePlaceholderL;

export { SvgRsProfilePlaceholderL$1 as default };
